"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeather = void 0;
const environment_1 = require("../utils/environment");
const useWeather = () => {
    const apiGateway = (0, environment_1.getWeatherApiGateway)();
    const fetchWeather = async (lat, long) => {
        try {
            const response = await fetch(`${apiGateway}?lat=${lat}&long=${long}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        }
        catch (error) {
            console.error('Error fetching weather data:', error);
            throw new Error('Failed to fetch weather data');
        }
    };
    return { fetchWeather };
};
exports.useWeather = useWeather;
